import React, {Component} from 'react';

import ProcessStyle from './processStyles';

class Process extends Component {
    render() {
        return (
            <div className="container">
                <ul className="process">
                    <li className="process__item">
                        <span className="process__number">1</span>
                        <span className="process__title">Scope definition</span>
                        <span className="process__subtitle">Once we know the site's goals, we can define the scope of
                            the project. I.e., what web pages and features the site requires to fulfill the goal, and
                            the timeline for building those out.</span>
                    </li>

                    <li className="process__item">
                        <span className="process__number">2</span>
                        <span className="process__title">Wireframe and prototype Creation</span>
                        <span className="process__subtitle">Once we know what we have to build we can move to the next
                            step i.e. sketching it followed by creating a prototype for it.</span>
                    </li>

                    <li className="process__item">
                        <span className="process__number">3</span>
                        <span className="process__title">Website Design</span>
                        <span className="process__subtitle">The next critical stage of the website design process is
                            designing the website itself.</span>
                    </li>

                    <li className="process__item">
                        <span className="process__number">4</span>
                        <span className="process__title">Website Development</span>
                        <span className="process__subtitle">In this web development stage, the website development team
                            takes individual elements of the website and uses them to create a functional website.</span>
                    </li>

                    <li className="process__item">
                        <span className="process__number">5</span>
                        <span className="process__title">Website Testing and Deployment</span>
                        <span className="process__subtitle">The fifth and final stage of the website is the testing
                            and deployment process. In this stage, the website designer adds final touches to the site
                            and tests the website before deployment. The designer will test the complete functionality
                            of the site to ensure that it runs smoothly without any glitch.</span>
                    </li>
                </ul>
                <ProcessStyle/>
            </div>
        );
    }
}

export default Process;
